import { create } from 'zustand';
import { SharingPermissionException } from 'common/src/utils/types';
import { getExporterExceptions } from 'common/src/api/sharing-permissions';

interface SharingStore {
  exceptions: SharingPermissionException[];
  isLoading: boolean;
  lastFetched: number | null;

  fetchExceptions: (exporterId: number) => Promise<void>;
  isRestricted: (speciesId: number, season?: string) => boolean;
  clearExceptions: () => void;
}

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

const useSharingStore = create<SharingStore>((set, get) => ({
  exceptions: [],
  isLoading: false,
  lastFetched: null,

  fetchExceptions: async (exporterId: number) => {
    const { lastFetched } = get();
    const now = Date.now();

    // Use cache if fresh (within 5 minutes)
    if (lastFetched && now - lastFetched < CACHE_DURATION) {
      return;
    }

    set({ isLoading: true });
    try {
      const exceptions = await getExporterExceptions(exporterId);
      set({ exceptions, lastFetched: now, isLoading: false });
    } catch (error) {
      console.error('Error fetching sharing exceptions:', error);
      set({ isLoading: false });
    }
  },

  isRestricted: (speciesId: number, season?: string) => {
    const { exceptions } = get();

    console.log('🔍 isRestricted check:', {
      speciesId,
      season,
      exceptionsCount: exceptions.length,
      exceptions: exceptions.map(e => ({ species_id: e.species_id, season: e.season }))
    });

    const result = exceptions.some(
      (exc) =>
        exc.species_id === speciesId &&
        (!exc.season || !season || exc.season === season)
    );

    console.log('🔍 isRestricted result:', result);

    return result;
  },

  clearExceptions: () => {
    set({ exceptions: [], lastFetched: null });
  },
}));

export default useSharingStore;
